import React from "react";
import Landing from "./landing/Landing";
import { createTheme, ThemeProvider } from "@mui/material";
import LanguageDetector from "i18next-browser-languagedetector";
import enTranslations from "./locales/en/translation.json";
import hiTranslations from "./locales/hi/translation.json";
import guTranslations from "./locales/gu/translation.json";
import paTranslation from "./locales/pa/translation.json";
import mrTranslation from "./locales/mr/translation.json";
import taTranslation from "./locales/ta/translation.json";
import knTranslation from "./locales/kn/translation.json";
import orTranslation from "./locales/or/translation.json";
import { I18nextProvider } from "react-i18next";
import i18n from "i18next";

i18n.use(LanguageDetector).init({
  resources: {
    en: {
      translation: enTranslations,
    },
    hi: {
      translation: hiTranslations, //Hindi Translation
    },
    gu: {
      translation: guTranslations, // Gujarati translations
    },
    pa: {
      translation: paTranslation, //punjabi translation
    },
    mr: {
      translation: mrTranslation, //Marathi translations
    },
    ta: {
      translation: taTranslation, //Tamil translations
    },
    kn: {
      translation: knTranslation, //Kannada translations
    },
    or: {
      translation: orTranslation, //Oriya translations
    },
  },
  lng: "en",
  fallbackLng: "en", // Default language
  debug: true, // Enable debug mode
  interpolation: {
    escapeValue: false, // React already safely escapes interpolated values
  },
});

const theme = createTheme({
  palette: {
    primary: {
      main: "#4CAF50",
    },
    secondary: {
      main: "#795548",
    },
  },
  typography: {
    fontFamily: "Inter, Arial, sans-serif",
  },
  breakpoints: {
    values: {
      xs: 0,
      sm: 600,
      md: 960,
      lg: 1280,
      xl: 1920,
    },
  },
});

const App = () => {
  return (
    <>
      <ThemeProvider theme={theme}>
        <I18nextProvider i18n={i18n}>
          <Landing />
        </I18nextProvider>
      </ThemeProvider>
    </>
  );
};

export default App;
